import { render, staticRenderFns } from "./RegistrationTitle.vue?vue&type=template&id=7ce025d2&"
import script from "./RegistrationTitle.vue?vue&type=script&lang=js&"
export * from "./RegistrationTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports